import { render, staticRenderFns } from "./WorkHeaderWrapper.vue?vue&type=template&id=97f8e628"
import script from "./WorkHeaderWrapper.vue?vue&type=script&lang=js"
export * from "./WorkHeaderWrapper.vue?vue&type=script&lang=js"
import style0 from "./WorkHeaderWrapper.vue?vue&type=style&index=0&id=97f8e628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports